<template>
	<div class="card">
		<header class="card-header language-list">
			<h3 class="card-title">Content</h3>
			<lang-selector></lang-selector>
		</header>
		<div class="card-body">
			<div class="form-group">
				<label for="review-tagline">Tagline</label>
				<input @keypress="canEdit" id="review-tagline" type="text" v-model="editorContent.translations[clickedLang].tagline" :disabled="userRoles.includes('users.translator') && clickedLang === defaultLocale">
				<p class="input-error" v-if="errors.errors[errorTaglineCurrentLanguage]">{{ errors.errors[errorTaglineCurrentLanguage] }}</p>
			</div>
			<div class="form-group">
				<label for="review-intro">Above the Fold Intro</label>
				<editor
						v-model="editorContent.translations[clickedLang].above_the_fold"
						id="review-intro"
						:api-key="tinyMCEApiKey"
						:init="tinyMCEConfigOrig"
						:disabled="userRoles.includes('users.translator') && clickedLang === defaultLocale"
				/>
				<p class="input-error" v-if="errors.errors[errorAboveTheFoldCurrentLanguage]">{{ errors.errors[errorAboveTheFoldCurrentLanguage] }}</p>
			</div>
			<div class="form-group">
				<label for="review-main-copy">Review Main Copy</label>
				<editor
						v-model="editorContent.translations[clickedLang].content"
						id="review-main-copy"
						:api-key="tinyMCEApiKey"
						:init="tinyMCEConfig"
						:disabled="userRoles.includes('users.translator') && clickedLang === defaultLocale"
				/>
				<p class="input-error" v-if="errors.errors[errorContentCurrentLanguage]">{{ errors.errors[errorContentCurrentLanguage] }}</p>
			</div>
			<hr class="hr-small">
			<div class="form-group">
				<label for="card-title">Card Title</label>
				<input @keypress="canEdit" id="card-title" type="text" v-model="editorContent.card_title" :disabled="userRoles.includes('users.translator') && clickedLang === defaultLocale">
			</div>
			<div class="form-group">
				<label for="card-description">Card Description</label>
				<textarea @keypress="canEdit" id="card-description" type="text" v-model="editorContent.card_description" :disabled="userRoles.includes('users.translator') && clickedLang === defaultLocale"></textarea>
			</div>
		</div>
	</div>
</template>

<script>
	import {eventBus} from "../../../app";

	export default {
		props: {
			editorContent: {
				required: true
			},
			errors: {}
		},
		data() {
			return {
				defaultLocale: this.$defaultLanguage.locale,
				userRoles: this.$currentUserRoles,
				clickedLang: this.$defaultLanguage.locale,
				tinyMCEApiKey: this.$tinyMCEApiKey,
				tinyMCEConfig: this.$tinyMCEConfig,
				tinyMCEConfigOrig: this.$tinyMCEConfig,
			}
		},
		created() {
			let vm = this;

			let tinyMCEMenu = {
				menubar: 'file edit view insert format tools table help shortcodes',
				menu: {
					shortcodes: { title: 'Shortcodes', items: 'blockquote blockquote-link speed-test' }
				},
				style_formats: [
					{title: 'Headers', items: [
							{title: 'Header 1', format: 'h1'},
							{title: 'Header 2', format: 'h2'},
							{title: 'Header 3', format: 'h3'},
							{title: 'Header 4', format: 'h4'},
							{title: 'Header 5', format: 'h5'},
							{title: 'Header 6', format: 'h6'}
						]},
					{title: 'Inline', items: [
							{title: 'Bold', icon: 'bold', format: 'bold'},
							{title: 'Italic', icon: 'italic', format: 'italic'},
							{title: 'Underline', icon: 'underline', format: 'underline'},
							{title: 'Strikethrough', icon: 'strikethrough', format: 'strikethrough'},
							{title: 'Superscript', icon: 'superscript', format: 'superscript'},
							{title: 'Subscript', icon: 'subscript', format: 'subscript'},
							{title: 'Code', icon: 'code', format: 'code'}
						]},
					{title: 'Blocks', items: [
							{title: 'Paragraph', format: 'p'},
							{title: 'Div', format: 'div'},
							{title: 'Pre', format: 'pre'}
						]},
					{title: 'Alignment', items: [
							{title: 'Left', icon: 'alignleft', format: 'alignleft'},
							{title: 'Center', icon: 'aligncenter', format: 'aligncenter'},
							{title: 'Right', icon: 'alignright', format: 'alignright'},
							{title: 'Justify', icon: 'alignjustify', format: 'alignjustify'}
						]}
				],
				setup: function (editor) {
					editor.ui.registry.addNestedMenuItem('blockquote', {
						text: 'Blockquotes',
						getSubmenuItems: function () {
							return [
								{
									type: 'menuitem',
									text: 'Blockquote without link',
									onAction: function () {
										editor.insertContent('[[post-object type="blockquote" author="AUTHOR HERE"]] QUOTE HERE [[/post-object]]');
									}
								},
								{
									type: 'menuitem',
									text: 'Blockquote with link',
									onAction: function () {
										editor.insertContent('[[post-object type="blockquote" author="AUTHOR HERE" author-link="LINK HERE"]] QUOTE HERE [[/post-object]]');
									}
								}
							];
						}
					});

					editor.ui.registry.addNestedMenuItem('speed-test', {
						text: 'Speed Test',
						getSubmenuItems: function () {
							return [
								{
									type: 'menuitem',
									text: 'Speed Test Chart',
									onAction: function () {
										editor.insertContent('[[post-object type="review_speed_test_chart" /]]');
									}
								},
								{
									type: 'menuitem',
									text: 'Speed Test Count',
									onAction: function () {
										editor.insertContent('[[post-object type="speed_test_count" /]]');
									}
								},
								{
									type: 'menuitem',
									text: 'Speed Test Table',
									onAction: function () {
										editor.insertContent('[[post-object type="speed_test_table" /]]');
									}
								}
							];
						}
					});
				}
			}
			vm.tinyMCEConfig = Object.assign(tinyMCEMenu, vm.tinyMCEConfig);
		},
		mounted() {
			let vm = this;
			// When setActiveStatus method ran, change selected data in form fields
			/* From LangSelector */
			eventBus.$on('setActiveStatus', function (clickedLang) {
				vm.clickedLang = clickedLang;
			});

			eventBus.$on('onTocUpdate', function() {
				vm.sendToC();
			});

			vm.sendToC();
		},
		methods: {
			sendToC: function () {
				let vm = this;

				let parsedHtml = htmlparser.parseDOM(vm.editorContent.translations[vm.clickedLang].content);
				let h2s = htmlparser.DomUtils.findAll(function (element) {
					return element.name === 'h2'
				}, parsedHtml);

				eventBus.$emit('onReviewContentUpdate', h2s);
			},
			canEdit: function (event) {
				let vm = this;
				if(vm.userRoles.includes('users.translator') && vm.clickedLang === vm.defaultLocale) {
					event.preventDefault();
					event.stopPropagation();
				}
			}
		},
		computed: {
			errorTaglineCurrentLanguage: function () {
				return 'providerReviewEditorContent_translations_' + this.clickedLang + '_tagline';
			},
			errorAboveTheFoldCurrentLanguage: function () {
				return 'providerReviewEditorContent_translations_' + this.clickedLang + '_above_the_fold';
			},
			errorContentCurrentLanguage: function () {
				return 'providerReviewEditorContent_translations_' + this.clickedLang + '_content';
			},
		}
	}
</script>

<style scoped>

</style>
